import React, {useState} from 'react';

interface searchInputProps {
  onSearch: (id: string) => void;
}

export const SearchInput: React.FC<searchInputProps> = ({onSearch}) => {
  const [searchedId, setSearchedId] = useState('');
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchedId(event.target.value.toLowerCase());
  };
  const handleSearch = () => {
    onSearch(searchedId.trim());
  };

  return (
    <div>
      <p>enter ID to searh</p>
      <input type="text" value={searchedId} onChange={onInputChange} />
      <button onClick={handleSearch}>Search</button>
    </div>
  );
};
